var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.3589,
    y: 72.9458,
    width: 77.2822,
    height: 60.1084,
    rx: 2,
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.8262 94.4131L98.7571 101.863C101.383 103.379 104.618 103.379 107.243 101.863L120.174 94.4131",
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.989 152.375L158.815 169.548L148.511 159.244",
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.174 178.301C86.4767 186.07 51.709 170.58 34.9484 140.332C18.1879 110.084 23.4881 72.3932 47.9407 47.9407C72.3932 23.4881 110.084 18.1879 140.332 34.9484C170.58 51.709 186.07 86.4767 178.301 120.174",
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/emailSuccess.f4713bf5ad28062e0cf62dc411d575f1.svg";
export { ForwardRef as ReactComponent };